module.exports = __webpack_public_path__ + "img/s00177.a22b7903.png";